export enum FORM_NAME {
  CREATE_SPECIALDAY = 'CREATE_SPECIALDAY',
  UPDATE_SPECIALDAY = 'UPDATE_SPECIALDAY',
}
